<template>
  <pt-export-history class="pt-export-history__page"></pt-export-history>
</template>

<script>
import PtExportHistory from 'cps//pt-export-history/withData'
export default {
  name: 'pt-export-history__view',
  components: {
    'pt-export-history': PtExportHistory
  }
}
</script>
